import type { NavItems } from '@ksyos/design-system';
import { useLocation } from '@ksyos/router';

export function useHasActiveNavigationItem(items: NavItems[] | undefined) {
    const location = useLocation();

    if (!items) {
        return false;
    }

    return items.some((subItem) => {
        if ('to' in subItem && subItem.to === location.pathname) {
            return true;
        }
        if (subItem.items) {
            return subItem.items.some((childItem) => 'to' in childItem && childItem.to === location.pathname);
        }

        return false;
    });
}
